export default __webpack_public_path__ + "static/media/BB.cc38f790.svg";